import { motion } from "framer-motion";
import { MaskLine } from "@/components/Reveal";

export const FinalCTA = ({ onScrollTo }) => (
  <section data-testid="final-cta" className="relative py-40 sm:py-56 border-t border-white/5 overflow-hidden">
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <div className="w-[600px] h-[600px] rounded-full bg-[#d4c4a8]/5 blur-[120px]" />
    </div>
    <div className="relative max-w-screen-2xl mx-auto px-6 sm:px-10 text-center">
      <h2 className="font-serif font-light text-4xl sm:text-6xl lg:text-8xl tracking-tight uppercase leading-[0.98] max-w-6xl mx-auto">
        <MaskLine>Bereit für etwas,</MaskLine>
        <MaskLine delay={0.08} className="text-[#d4c4a8] italic">das man nicht vergisst?</MaskLine>
      </h2>
      <motion.p
        className="mt-8 font-body text-lg text-[#a1a1aa]"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.3 }}
      >
        Erzählen Sie uns von Ihrem Projekt.
      </motion.p>
      <div className="mt-12 flex flex-wrap gap-4 justify-center">
        <button data-testid="finalcta-project" onClick={() => onScrollTo("#kontakt")} className="btn-gold">Projekt starten</button>
        <button data-testid="finalcta-consult" onClick={() => onScrollTo("#booking")} className="btn-ghost">Kostenloses Beratungsgespräch</button>
      </div>
    </div>
  </section>
);
